import React, { useEffect, useMemo, useState } from "react";
import { getEUSanctionsListProgrammes } from "common/services/sanctions-list.service";
import { normalize } from "common/lib/normalize";
import { FilterValueSelect } from "Components/Common/TableFilters";

type ProgramFilterProps = {
  onChange: (value: any) => void;
  value: any;
};

const ProgramFilter = ({ onChange, value }: ProgramFilterProps) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getEUSanctionsListProgrammes();

        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    const uniqueOptions = new Set();
    return data
      .map((el: any) => {
        return {
          value: el?.programme,
          label: el?.programme,
        };
      })
      .filter((option) => {
        if (uniqueOptions.has(option.value)) {
          return false;
        } else {
          uniqueOptions.add(option.value);
          return true;
        }
      });
  }, [data]);

  return (
    <FilterValueSelect
      id="euProgramFilter"
      placeholder="Select Program"
      value={value}
      onChange={onChange}
      options={options}
      isLoading={loading}
    />
  );
};

export default ProgramFilter;
